const initialState = {
  terms : false,
  saveInfoShipping : false,
  conditions : false
}

const termsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'TERMS_CONDITIONS': {
      return {...state, ...action.payload}
    }
    default: {
      return state
    }
  }
}

export default termsReducer
